import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import api from "./plugins/axios";
import Notifications from "vue-notification";
import wysiwyg from "vue-wysiwyg";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import { wysiwygSettings } from "./config/constants";
import { VueMaskDirective } from "v-mask";
import VueClipboards from "vue-clipboards";
import pusher from "./plugins/pusher";

Vue.directive("mask", VueMaskDirective);
Vue.use(VueClipboards);
Vue.config.productionTip = false;
Vue.use(Notifications);
Vue.use(wysiwyg, wysiwygSettings);
Vue.prototype.$axios = api;

router.beforeEach((to, from, next) => {
  if (!pusher.isRegistered) {
    pusher.registerChannels();
  }
  next();
});

const vm = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

export { vm };
